import * as React from 'react';
import {styled} from '@packages/utilities/styled';
import {visuallyHiddenStyles} from '@packages/systems/spring';
import {mergeRefs} from '../utils/mergeRefs';
import {checkboxStyle} from './CheckboxStyle';

const checkboxInputStyle = (props: any) => {
  const {width, height} = checkboxStyle(props);
  return {
    ...visuallyHiddenStyles,
    alignItems: 'center',
    bottom: 0,
    display: 'flex',
    height,
    justifyContent: 'center',
    left: 0,
    right: 0,
    top: 0,
    width,
  };
};

const StyledInput = styled('input')(checkboxInputStyle);

// @ts-expect-error - TS7031 - Binding element 'ref' implicitly has an 'any' type. | TS7031 - Binding element 'indeterminate' implicitly has an 'any' type.
function useInputIndeterminateRef({ref, indeterminate}) {
  const _inputRef = React.useRef(undefined);

  React.useEffect(() => {
    if (_inputRef.current != null) {
      // @ts-expect-error - TS2339 - Property 'indeterminate' does not exist on type 'never'.
      _inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const setRefIndeterminate = (checkbox: HTMLInputElement | null) => {
    // @ts-expect-error - TS2322 - Type 'HTMLInputElement | null' is not assignable to type 'undefined'.
    _inputRef.current = checkbox;
    if (checkbox && indeterminate != null) {
      checkbox.indeterminate = indeterminate;
    }
  };

  return mergeRefs([ref, setRefIndeterminate]);
}

export const CheckboxInput = React.forwardRef<any, any>((props, ref) => {
  const {
    'data-automation-id': dataAutomationId,
    indeterminate,
    onChange,
    sizing,
    ...rest
  } = props;

  const inputRef = useInputIndeterminateRef({indeterminate, ref});

  return (
    <StyledInput
      data-automation-id={dataAutomationId}
      data-indeterminate={indeterminate}
      onChange={onChange}
      ref={inputRef}
      sizing={sizing}
      {...rest}
    />
  );
});

export default CheckboxInput;
